import PrimaryButton from 'components/atoms/buttons/PrimaryButton';
import GridBox from 'components/atoms/GridBox';
import styled from 'styled-components';
import { FC } from 'react';
import BREAKPOINTS from 'lib/constants/breakpoints';

const ButtonBarWrapper = styled(GridBox)`
  padding: 32px 0;
`;

const Button = styled(PrimaryButton)`
  height: 47px;
  line-height: 47px;
  padding: 0 70px;

  @media (max-width: ${BREAKPOINTS.medium}) {
    width: 100%;
  }
`;

const OnboardingButtonBar: FC<{
  text?: string;
  loading: boolean;
  disabled?: boolean;
  pink?: boolean;
}> = ({
  text = 'Próximo',
  loading,
  disabled = false,
  children,
  pink = true,
}) => (
  <ButtonBarWrapper justifyContent="center">
    <Button
      pink={pink}
      boxShadow={pink}
      type={loading ? 'button' : 'submit'}
      disabled={disabled}
      isLoading={loading}
    >
      {text}
    </Button>
    {children}
  </ButtonBarWrapper>
);

export default OnboardingButtonBar;
